import React, { type HTMLAttributes } from 'react';

import { WysiwygField, isExternalLink } from '@uncinc/uncinc-react-kitchen-sink';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { CoreLink } from '@uncinc/react-drupal-core';

import type { TaxonomyTheme } from '../../../../types/uncinc_profile/taxonomy';
import { DynamicMediaItem } from '../../../../components';

import './style.scss';

interface TaxonomyThemeTeaserProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<TaxonomyTheme>;
}

const TaxonomyThemeTeaser: React.FC<TaxonomyThemeTeaserProps> = ({ entity: theme }) => {
  const data = theme.toJS();
  const link = data.field_link[0].alias ?? data.field_link[0].uri;
  const LinkComponent = isExternalLink(link) ? 'a' : CoreLink;

  return (
    <div className="col-12 col-md-6 TaxonomyThemeTeaser__item">
      <div className="TaxonomyThemeTeaser__imageContainer">
        <LinkComponent
          title={data.field_link[0].title}
          href={link}
        >
          <DynamicMediaItem className="TaxonomyThemeTeaser__image" media={data.field_image[0]} imageAspectRatio="16_9" />
          <div className="TaxonomyThemeTeaser__item__titleDiv">
            <div className="TaxonomyThemeTeaser__item__title">
              {data.name[0].value}
            </div>
          </div>
        </LinkComponent>
      </div>
      <div className="TaxonomyThemeTeaser__item__bodyDiv">
        <WysiwygField className="TaxonomyThemeTeaser__item__body" html={data.field_body[0].value} />
        <LinkComponent
          href={link}
          className="TaxonomyThemeTeaser__item__link"
        >
          <span>{data.field_link[0].title}</span>
          <i className="icon icon-arrow-right icon-variant-1" />
        </LinkComponent>
      </div>
    </div>
  );
};

export default TaxonomyThemeTeaser;
